import { render, staticRenderFns } from "./life.vue?vue&type=template&id=327806d5&scoped=true&"
import script from "./life.vue?vue&type=script&lang=ts&"
export * from "./life.vue?vue&type=script&lang=ts&"
import style0 from "./life.vue?vue&type=style&index=0&id=327806d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327806d5",
  null
  
)

export default component.exports